/**
 * Trailer セクション幅（1920px 基準のデザイン）。
 * 従来の % 指定を各ブレークポイント参考幅で px→rem 換算。
 * padding（base 5% / sm 8% / md 10% / lg+ 12%）込みの実効幅に合わせる。
 */
export const trailerContentMaxW = {
  base: "19.6875rem", // 375px 幅時 ≒ 93%×90%
  sm: "24.6875rem", // 480px 幅時
  md: "36.875rem", // 768px 幅時
  lg: "44.3125rem", // 992px 幅時
  xl: "52.3125rem", // 1280px 幅時
  /** 1536px 幅時の実効値。1920px 以上は sx で上書き */
  "2xl": "62.75rem", // 1004px @1536
} as const;

/** 1920px 以上：従来 86% の実効 max-width（1255px） */
export const trailerContentMaxWDesktopSx = {
  "@media (min-width: 1920px)": {
    maxWidth: "78.4375rem", // 1255px
  },
} as const;

export const trailerVideoMaxW = {
  base: trailerContentMaxW.base,
  sm: trailerContentMaxW.sm,
  md: "46.875rem", // 750px @768 (80%)
  lg: "47.5625rem", // 761px @992
  xl: "45.625rem", // 730px @1280 (70%)
  "2xl": "44.8125rem", // 717px @1536
} as const;

export const trailerVideoMaxWDesktopSx = {
  "@media (min-width: 1920px)": {
    maxWidth: "63.8125rem", // 1021px (70% @1920)
  },
} as const;

/** 背景 HaikeiA の srcset sizes（vw 不使用） */
export const trailerHeroSizes =
  "(min-width: 1280px) 1920px, (min-width: 768px) 1280px, 768px";

/** RoyalAlbertHall の srcset sizes */
export const royalAlbertHallSizes =
  "(min-width: 1920px) 1255px, (min-width: 1280px) 837px, (min-width: 992px) 709px, 590px";
